module.exports = __webpack_public_path__ + "static/media/242-madagascar.418ff817.svg";